export default "skymp5-front/05bc1c771a7f9d9fa958eab5889558f7.svg";